var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuFreePresent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2925 7.33626C14.6562 6.16748 16.7525 6.57028 17.5858 8.1612L20.7128 14.131C20.8695 14.4302 20.8403 14.7928 20.6376 15.0629C20.3697 15.4202 19.8758 15.5187 19.4914 15.2915L13.6894 11.863C12.0408 10.8888 11.8386 8.58248 13.2925 7.33626Z",
    stroke: "#FF791C",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7998 7.96577C28.0969 9.20796 27.902 11.3337 26.4007 12.3193L20.7669 16.0177C20.4846 16.203 20.1209 16.2095 19.8321 16.0344C19.4502 15.8028 19.3037 15.3211 19.4921 14.9161L22.334 8.80544C23.1415 7.0691 25.4168 6.6413 26.7998 7.96577Z",
    stroke: "#FF791C",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 15.5C6.66663 14.1193 7.78591 13 9.16663 13H30.8333C32.214 13 33.3333 14.1193 33.3333 15.5V17.1667C33.3333 18.5474 32.214 19.6667 30.8333 19.6667H9.16662C7.78591 19.6667 6.66663 18.5474 6.66663 17.1667V15.5Z",
    fill: "#5C5B5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16663 19.6666H30.8333V30.5C30.8333 31.8807 29.714 33 28.3333 33H11.6666C10.2859 33 9.16663 31.8807 9.16663 30.5V19.6666Z",
    fill: "#D1CFCD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4166 13L20.4166 33",
    stroke: "#FF964D",
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuFreePresent);
export default __webpack_public_path__ + "static/media/wikiMenuFreePresent.53d5a487380e6f50f0fb8bc1e2bab806.svg";
export { ForwardRef as ReactComponent };